/**
 * Animation constants for the Strategy Swim Lane Board.
 *
 * Spring physics tuned for a settled, organic feel — board reorganization
 * completes within ~600ms on a mid-range device. Source of truth for all
 * framer-motion <motion.*> components in `components/strategy/`.
 *
 * See docs/creative-workbench/requirements/7_strategic_swim_lanes/
 *     TECHNICAL_SPECIFICATION.md §4.2
 */

export const SWIM_LANE_SPRING = {
  type: 'spring' as const,
  stiffness: 280,
  damping: 30,
  mass: 0.8,
};

export const CARD_SPRING = {
  type: 'spring' as const,
  stiffness: 260,
  damping: 28,
  mass: 0.7,
};

export const HEADER_TRANSITION = {
  duration: 0.22,
  ease: 'easeInOut' as const,
};

export const CARD_EXIT = {
  scale: 0.9,
  opacity: 0,
  transition: { duration: 0.15 },
};

export const CARD_ENTER = {
  initial: { scale: 0.95, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  transition: { duration: 0.2 },
};
